import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import ProductItem from './ProductItem'
import packStore from '../../stores/packStore'
import NoSearchResults from './NoSearchResults'
import { inject, observer } from 'mobx-react'
import { observe } from 'mobx'
import history from '../common/history.js'
import { Waypoint } from 'react-waypoint'
import { debounce } from '../../helpers/debounce'
import { ReactComponent as ArrowSortDown } from '#images/arrow-sort-down.svg'

const itemsWindow = 1917;

@inject('cloudItemsStore', 'filtersStore', 'playlistStore', 'infoStore', 'successStore', 'modalStore')
@observer
class ProductItems extends Component {
  constructor(props) {
    super(props);
    this.items = React.createRef();
    this.direction = null;
    this.state = { prev: [], loaded: [], ready: false };
  }

  removeScroll() {
    const { modalStore } = this.props
    const itemNode = ReactDOM.findDOMNode(this.items.current);
    if(itemNode) {
      itemNode.classList.remove('flex', 'overflow-y-auto')
      itemNode.classList.add('block', 'overflow-y-hidden', 'pointer-events-none')
      if (!modalStore.visibleModal) modalStore.show('loading')
    }
  }

  addScroll() {
    const { modalStore } = this.props
    const itemNode = ReactDOM.findDOMNode(this.items.current);
    if(itemNode) {
      itemNode.classList.add('flex', 'overflow-y-auto')
      itemNode.classList.remove('block', 'overflow-y-hidden', 'pointer-events-none')
      if (modalStore.visibleModal === 'loading') modalStore.hide()
    }
  }

  async fetch(params = {}) {
    if (!this._isMounted) { return }

    // When the loader is shown, remove body scroll
    document.body.style.overflow = 'hidden';
    this.removeScroll();

    if(this.props.filtersStore.page === 1) {
      this.props.cloudItemsStore.topMargin = 0;
      this.setState((state, props) => ({ loaded: [], prev: [], ready: false }));
      if(this.items.current) { this.items.current.scrollTop = 0; }
    }
    if (this.props.id) {
      if (!packStore.tagsLoaded) return false;
      this.props.filtersStore.q = '';
    }
    if(this.props.packItems) { params['product_id'] = this.props.id }
    if(this.props.collectionId) { params['collection'] = this.props.collectionId }
    if(this.props.favourites) { params['user_favourites'] = true }
    if(this.props.favweb) { params['favweb'] = true }
    var nItems = await this.props.cloudItemsStore.fetchCloudItems(params);
    nItems = nItems.map((i) => {
      return {...i, tags: i.tags.map((t) => {return {...t};}), key: i.key.map((k) => {return {...k};})};
    });
    var secondPageOrGreater = this.props.filtersStore.page > 1;
    // buffer for scrolling back
    if(secondPageOrGreater) {
      // allow reloading items on the same page w/o direction
      if(this.direction === 'up' || this.direction === null) {
        this.setState((state, props) => ({loaded: nItems, ready: true}));
      }
      if(this.direction === 'down') {
        // create 2 page buffer
        const buf = (this.state.prev || []).slice(0).concat(nItems);
        this.setState((state, props) => ({ prev: nItems, loaded: buf, ready: true }));
      }
      this.updateScroll();
      if (this.direction === 'down') {
        let prevScroll = this.items.current.scrollTop;
        // move margins for 2 page buffer
        this.props.cloudItemsStore.topMarginMinusOnePage();
        this.props.cloudItemsStore.bottomMarginMinusOnePage();
        this.items.current.scrollTop = prevScroll; // prevent scroll bouncing
      }
    } else {
      this.setState((state, props) => ({ prev: nItems, loaded: nItems, ready: true }));
    }

    // When the loader is hidden, add body scroll
    document.body.style.overflow = 'auto';

    this.addScroll();
    if(!secondPageOrGreater) { this.updateScroll(); }
    this.direction = null;
  }

  markAsBought() {
    const { successStore } = this.props;
    const newItems = this.state.loaded.map((item) => {
      const newItem = successStore.items.find(nItem => nItem.id === item.id)
      if (newItem) {
        return {...item, ...newItem, yellowLabel: true, owned: true};
      }
      return {...item}
    });
    successStore.items.replace([]);
    this.setState((state, props) => ({ loaded: newItems, ready: true }));
  }

  componentDidMount() {
    const {  library, filtersStore, cloudItemsStore, skipInitialFetch } = this.props;
    this._isMounted = true;

    if (library) {
      filtersStore.reset({'shop': false});
      filtersStore.clearFilters();
    } else {
      filtersStore.reset();
      filtersStore.load();
    }
    cloudItemsStore.calculateBottomMargin();
    cloudItemsStore.calculateTopMargin();

    this.traversingIndexDisposer = observe(this.props.playlistStore, 'traversingIndex', change => {
      if(this.items.current && this.props.playlistStore.traversingMode === 'itemlist') {
        let offsetStart = this.items.current.children[1].offsetTop
        let item = this.items.current.children[change.newValue+1]
        this.items.current.scrollTop = item.offsetTop - offsetStart
      }
    })

    let didMount = true
    this.fetchDisposer = observe(filtersStore, 'fetch', change => {
      if (change.newValue && (this.state.ready || !skipInitialFetch || didMount)) {
        if (this.fetchDebounce) {
          filtersStore.fetch = false
          return this.fetchDebounce()
        }

        this.fetchDebounce = debounce(() => {
          didMount = false
          this.fetch()
        })
        this.fetchDebounce()
      }
      filtersStore.fetch = false
    })

    if (!skipInitialFetch) {
      filtersStore.fetch = true
    }
  }

  componentDidUpdate(prevProps, _prevState) {
    const { id, infoStore } = this.props;
    if (id !== prevProps.id) {
      var itemNode = ReactDOM.findDOMNode(this.items.current);
      itemNode.classList.add('flex', 'overflow-y-auto')
      itemNode.classList.remove('block', 'overflow-y-hidden', 'pointer-events-none')
      this.items.current.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    const { modalStore, cloudItemsStore } = this.props
    this._isMounted = false
    this.traversingIndexDisposer && this.traversingIndexDisposer()
    this.fetchDisposer && this.fetchDisposer()
    if (modalStore.visibleModal !== 'collection') modalStore.hide()
    cloudItemsStore.reset()
  }

  async sortItems() {
    const { filtersStore } = this.props
    const { sort: { filename } } = filtersStore
    filtersStore.sort.filename = (filename === 'desc') ? 'asc' : 'desc'
    filtersStore.page = 1
    await this.fetch()
    let params = this.props.filtersStore.toParams()
    history.push(`${window.location.pathname}?${params}`)
  }

  renderItems() {
    const { id, infoStore, collectionId } = this.props;
    return this.state.loaded.map(
      (item, i) =>
        <ProductItem
          homeOnFiltersClear={this.props.homeOnFiltersClear}
          removeLabelTag={!!id}
          userPoints={infoStore.points}
          coverVisible={true}
          checkBoxVisible={item.points !== null && !item.owned}
          key={item.id}
          n={i}
          item={item}
          collectionId={collectionId}
          fetchProductItems={() => this.fetch}
        />
    );
  }

  updateScroll() {
    if(this.direction === 'up') {
      let itemHeight = 67
      this.items.current.scrollTop = parseInt(
        this.props.cloudItemsStore.topMargin +
        (this.props.cloudItemsStore.meta.per_page * itemHeight) - this.height - 12
      ); // end of item window - 12 px
    }

    // prevent resetting `.scrollTop` when this.direction is `null`
    if (this.direction === 'down' || this.direction === null) {
      this.items.current.scrollTop = this.props.cloudItemsStore.topMargin + 3; // start of item window + margin
    }
  }

  up() {
    const { cloudItemsStore, filtersStore } = this.props

    if (!cloudItemsStore.isLoading && !this.direction && filtersStore.page > 1) {
      const pagesLoaded = (this.state.loaded.length === 200) ? 2 : 1
      this.props.cloudItemsStore.isLoading = true
      this.props.filtersStore.page = parseInt(filtersStore.page) - pagesLoaded;
      if (!filtersStore.page) { this.props.filtersStore.page = 1 }
      this.direction = 'up'
      this.fetch()
    }
  }

  down() {
    const { cloudItemsStore, filtersStore } = this.props
    if (!cloudItemsStore.isLoading && !this.direction && filtersStore.page < cloudItemsStore.meta.pages_count) {
      this.props.cloudItemsStore.isLoading = true
      this.props.filtersStore.page = parseInt(filtersStore.page) + 1
      this.direction = 'down'
      this.fetch()
    }
  }

  get readyAndEmpty() {
    return (this.state.ready && !this.state.loaded.length);
  }

  get height() {
    const { forceHeight } = this.props;

    if (forceHeight) {
      if (this.readyAndEmpty) return forceHeight - 203;
      return forceHeight;
    }

    if (this.readyAndEmpty) return itemsWindow - 203;
    return itemsWindow;
  }

  get heightClass() {
    const { forceHeight } = this.props

    const heights = {
      2217: 'h-[2217px]',
      1917: 'h-[1917px]',
      1901: 'h-[1901px]',
      1810: 'h-[1810px]',
    }
    const forcedHeights = {
      2217: 'h-[2014px]',
      1917: 'h-[1714px]',
      1901: 'h-[1698px]',
      1810: 'h-[1607px]',
    }

    if (forceHeight) return this.readyAndEmpty ? forcedHeights[forceHeight] : heights[forceHeight]

    return this.readyAndEmpty ? forcedHeights[itemsWindow] : heights[itemsWindow]
  }

  render() {
    const { successStore, noResultsTitle, noResultsNote, cloudItemsStore } = this.props
    const { topMargin, bottomMargin, isLoading } = cloudItemsStore
    const { sort } = this.props.filtersStore

    if (successStore.items.length) this.markAsBought()

    return (
      <div className='flex flex-col'>
        {
          !this.readyAndEmpty && (
            <div className='hidden lg:flex lg:justify-between text-gray-3 text-xs py-2'>
              <div className='w-[calc(5%+60px+0.5rem+(0.23*(100%-5%-60px-0.5rem)))] 2xl:w-[calc(5%+60px+0.5rem+(0.23*(100%-5%-60px-0.5rem)))]'></div>
              <div
                className='w-[calc(0.37*(100%-5%-60px-0.5rem))] flex items-center cursor-pointer 2xl:w-[calc(0.37*(100%-5%-60px-0.5rem))]'
                onClick={() => { this.sortItems() }}
              >
                <span>File</span>
                {
                  sort.filename && (
                    <span className='ml-auto'>
                      <ArrowSortDown class={`text-gray-5 ${sort.filename === 'desc' ? 'rotate-180' : ''}`}  />
                    </span>
                  )
                }
              </div>
              <div className='w-[calc(0.05*(100%-5%-60px-0.5rem))] 2xl:w-[calc(0.05*(100%-5%-60px-0.5rem))]'>BPM</div>
              <div className='w-[calc(0.09*(100%-5%-60px-0.5rem))] 2xl:w-[calc(0.09*(100%-5%-60px-0.5rem))]'>Key</div>
              <div className='w-[calc(0.1675*(100%-5%-60px-0.5rem))] lg:w-[calc(0.2*(100%-5%-60px-0.5rem))] 2xl:w-[calc(0.2*(100%-5%-60px-0.5rem))]'></div>
            </div>
          )
        }

        {
          this.readyAndEmpty && (
            <NoSearchResults title={noResultsTitle} note={noResultsNote} />
          )
        }

        <div
          ref={this.items}
          className={`box-border m-0 min-w-0 justify-start flex-nowrap flex flex-col overflow-y-auto [scrollbar-width:none] ${this.heightClass}`}
        >
          {
            (topMargin > 0 && !isLoading) && (
              <div
                className='flex justify-center p-4 items-end'
                style={{ height: `${topMargin}px`, minHeight: `${topMargin}px`, maxHeight: `${topMargin}px` }}
              >
                <Waypoint
                  onEnter={this.up.bind(this)}
                  style={{marginBottom: '10px'}}
                  height="1px"
                />
              </div>
            )
          }

          {
            isLoading && (
              <div
                className={`flex flex-col w-full justify-center items-center ${this.heightClass}`}>
              </div>
            )
          }

          {
            !isLoading && this.renderItems()
          }

          <div
            className='min-w-0 flex justify-center p-4 items-start flex-row'
            style={{ height: `${bottomMargin}px`, minHeight: `${bottomMargin}px`, maxHeight: `${bottomMargin}px` }}
          >
            {
              (bottomMargin > 0 && !isLoading && this.state.ready) && (
                <Waypoint
                  height="1px"
                  onEnter={this.down.bind(this)}
                />
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

export default ProductItems
